<script>
import { mapGetters } from 'vuex'
import LocationResource from '@/resources/location'

export default {
    name: 'WelcomeScreen',
    components: {},
    computed: {
        ...mapGetters(['userResource'])
    },
    props: {},
    data() {
        return {
            loading: true,
            locationResources: [],
            selectedLocation: null,
            includeBoards: true
        }
    },
    watch: {},
    methods: {
        async onSubmit() {
            this.$router.push({ name: 'menu', query: { location: this.selectedLocation.id, boards: this.includeBoards } })
        },
    },
    async mounted() {
        document.documentElement.setAttribute('data-theme', 'dark')
        this.locationResources = await LocationResource.all()
        this.selectedLocation = this.locationResources.find((location) => location.id == this.userResource.attributes.location)
        this.loading = false
    },
}
</script>

<template>
    <div class="display-unit" v-if="!loading">
        <b-container class="starting-form">
            <b-row>
                <b-col md="4" offset-md="4">
                    <form @submit.prevent="onSubmit">
                        <b-form-group label="Standort">
                            <b-form-select v-model="selectedLocation">
                                <b-form-select-option v-for="(locationResource, i) in locationResources" :key="i" :value="locationResource">{{ locationResource }}</b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                        <b-form-group label="Boards einbeziehen?">
                            <b-form-select v-model="includeBoards">
                                <b-form-select-option :value="true">Ja</b-form-select-option>
                                <b-form-select-option :value="false">Nein</b-form-select-option>
                            </b-form-select>
                        </b-form-group>
                        <b-button type="submit" class="col-12" variant="light">Menü anzeigen</b-button>
                    </form>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<style lang="scss" scoped>
.display-unit {
    color: #fff;

    table {
        color: #fff;
    }

    .starting-form {
        margin-top: 25%;
    }

    .podium {
        .card {
            background-color: #ffffff24;
        }

        .color-rank-1 {
            color: #f9d720;
        }

        .color-rank-2 {
            color: #fff;
        }

        .color-rank-3 {
            color: #eeae5a;
        }
    }

    .social {
        height: 21px;
        font-size: 14px;
        font-weight: 300;
        line-height: 14px;
        margin-top: -10px;

        a {
            color: #fff;
        }
    }
}
</style>
